import React, { forwardRef, useState } from 'react';

import { EyeIcon, EyeSlashIcon } from '../../assets';
import { IInputProps, Input } from '../Input';

import styles from './PasswordInput.module.scss';

export interface IPasswordInputProps extends Omit<IInputProps, 'type'> {}

export const PasswordInput = forwardRef<HTMLInputElement, IPasswordInputProps>(({ ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const Icon = showPassword ? EyeIcon : EyeSlashIcon;
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <Input
            type={showPassword ? 'text' : 'password'}
            {...props}
            ref={ref}
            suffix={<Icon onClick={togglePasswordVisibility} className={styles.icon} />}
        />
    );
});
